import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { style: {"margin-top":"10px"} }
const _hoisted_3 = { class: "ion-text-center ion-margin-top" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "container",
      innerHTML: _ctx.getSectorSlideHtml()
    }, null, 8, _hoisted_1),
    _createVNode(_component_ion_toolbar, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_label, null, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("h6", { style: {"margin-left":"10px","font-size":"13px"} }, "Sector", -1)
          ])),
          _: 1,
          __: [1]
        }),
        _createElementVNode("div", null, [
          _createVNode(_component_ion_chip, {
            class: _normalizeClass(["ion-no-margin", { 'active-tag': _ctx.selectedSegment == null }]),
            style: {"height":"24px","font-size":"13px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSelectSectorChip(_ctx.sector)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.sector.name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ion_toolbar, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_label, null, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("h6", { style: {"margin-left":"10px","font-size":"13px"} }, "Segments", -1)
          ])),
          _: 1,
          __: [2]
        }),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedSegments, (segment) => {
            return (_openBlock(), _createBlock(_component_ion_chip, {
              key: segment.id,
              class: _normalizeClass(["ion-no-margin", { 'active-tag': _ctx.selectedSegment?.id == segment.id }]),
              style: {"margin-end":"2px","margin-bottom":"2px","height":"24px","font-size":"13px"},
              onClick: ($event: any) => (_ctx.onSelectSegmentChip(segment))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(segment.name), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["class", "onClick"]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_component_ion_toolbar, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_label, null, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("h6", { style: {"margin-left":"10px","font-size":"13px"} }, "Locations", -1)
          ])),
          _: 1,
          __: [3]
        }),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location) => {
            return (_openBlock(), _createBlock(_component_ion_chip, {
              key: location.id,
              class: _normalizeClass(["ion-no-margin", _ctx.selectedLocationId == location.id ? 'active-tag': '']),
              style: {"margin-end":"2px","margin-bottom":"2px","height":"24px","font-size":"13px"},
              onClick: () => {
                  _ctx.selectedLocationId = location.id;
                  _ctx.loadExtraInfosLocation(_ctx.selectedSegment?.id);
                },
              color: _ctx.selectedLocationId == location.id ? '' : 'medium'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(location.name), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["onClick", "color", "class"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.selectedSegment]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ion_spinner)
      ], 512), [
        [_vShow, _ctx.loadingExtraInfo]
      ]),
      _withDirectives(_createVNode(_component_ion_accordion_group, { value: "mnc" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extraInfosGlobal, (info, key) => {
            return _withDirectives((_openBlock(), _createBlock(_component_ion_accordion, { key: key }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, {
                  color: "dark",
                  slot: "header"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(key), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_ion_list, { slot: "content" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info, (infoObj) => {
                      return (_openBlock(), _createBlock(_component_ion_item, {
                        key: infoObj.id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                target: "_blank",
                                href: infoObj.content
                              }, _toDisplayString(infoObj.name), 9, _hoisted_4)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)), [
              [_vShow, _ctx.selectedLocationId == null]
            ])
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extraInfosLocation, (info, key) => {
            return _withDirectives((_openBlock(), _createBlock(_component_ion_accordion, { key: key }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, {
                  color: "dark",
                  slot: "header"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(key), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_ion_list, { slot: "content" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info, (infoObj) => {
                      return (_openBlock(), _createBlock(_component_ion_item, {
                        key: infoObj.id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                target: "_blank",
                                href: infoObj.content
                              }, _toDisplayString(infoObj.name), 9, _hoisted_5)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)), [
              [_vShow, _ctx.selectedLocationId != null]
            ])
          }), 128)),
          _createVNode(_component_ion_accordion, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, {
                color: "dark",
                slot: "header"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode("Employers - local")
                    ])),
                    _: 1,
                    __: [4]
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_list, { slot: "content" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employers.local, (employer) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: employer.id
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              target: "_blank",
                              href: employer.company_url
                            }, _toDisplayString(employer.name), 9, _hoisted_6)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_accordion, { value: "mnc" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, {
                color: "dark",
                slot: "header"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("Employers - multinationals")
                    ])),
                    _: 1,
                    __: [5]
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_list, { slot: "content" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employers.mnc, (employer) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: employer.id
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              target: "_blank",
                              href: employer.company_url
                            }, _toDisplayString(employer.name), 9, _hoisted_7)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, !_ctx.loadingExtraInfo]
      ])
    ], 512), [
      [_vShow, _ctx.selectedSegment]
    ]),
    _withDirectives(_createVNode(_component_ion_accordion_group, { style: {"margin-top":"10px"} }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectorExtraInfo, (relatedInfo, type) => {
          return _withDirectives((_openBlock(), _createBlock(_component_ion_accordion, { key: type }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, {
                color: "dark",
                slot: "header"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(type), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_ion_list, { slot: "content" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relatedInfo, (info) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: info.name,
                      button: "",
                      detail: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              target: "_blank",
                              href: info.content
                            }, _toDisplayString(info.name), 9, _hoisted_8)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)), [
            [_vShow, type != '__CODE__']
          ])
        }), 128))
      ]),
      _: 1
    }, 512), [
      [_vShow, !_ctx.selectedSegment]
    ])
  ], 64))
}